import React from "react";
import { Route, Switch } from "react-router-dom";

import * as QueriesQL from "queries/domain-key";
import * as Section from "@repoflow/components/section";
import { Crumb } from "@repoflow/components/breadcrumb";

import * as ViewRoute from "./view";
import * as RemoveRoute from "./remove";

const LocalProvider = ({
  match: {
    params,
    params: { keyId },
  },
  children: Children,
}) => {
  const {
    base: parentBase,
    basepath: parentBasepath,
    schema,
    values: domain,
  } = Section.useSectionContext();

  const base = `${parentBase}/${keyId}`;
  const basepath = `${parentBasepath}/:keyId`;

  // Keyed on the entity, which is what the accidental remount used to do.
  //
  // Every screen below seeds its form state ONCE, from the entity this
  // route resolved. Until the render prop above was called rather than
  // rendered, React saw a new component type on every render and remounted
  // the lot — which reset those forms, and happened to be what made moving
  // from one keyId to another show the new one's values. It no longer
  // remounts for free, so the reset it was providing is asked for here.
  return (
    <Section.Provider
      key={keyId}
      schema={schema}
      base={base}
      basepath={basepath}
      attributes={{ ...params, domain }}
    >
      {/* Called, never rendered as an element — see Section.Provider. */}
      {Children({ base, basepath, params })}
    </Section.Provider>
  );
};

export const Content = (props) => {
  return (
    <LocalProvider {...props}>
      {({ params: { domain, name, keyId } }) => (
        <Section.Query
          query={QueriesQL.get}
          variables={{ domain, name, keyId }}
          datapath={"domains.get.keys.get"}
        >
          {ContentHandler}
        </Section.Query>
      )}
    </LocalProvider>
  );
};

function ContentHandler({ basepath }) {
  return (
    <Switch>
      <Route path={`${basepath}/remove`} component={RemoveRoute.Content} />
      <Route path={`${basepath}/`} component={ViewRoute.Content} />
    </Switch>
  );
}

export const Sidebar = () => (
  <>
    <RemoveRoute.Sidebar />
  </>
);

export function Indice(props) {
  return (
    <LocalProvider {...props}>
      {({ base, basepath, params: { keyId } }) => (
        <>
          <Crumb label={keyId} />
          <Switch>
            <Route path={`${basepath}/remove`} component={RemoveRoute.Indice} />
            <Route path={`${basepath}/`} component={ViewRoute.Indice} />
          </Switch>
        </>
      )}
    </LocalProvider>
  );
}
